import type { RouteRecordRaw } from 'vue-router';
import {
  BUSINESS_UNITS,
  BusinessUnitKey,
  getBusinessUnitConfig,
  type BusinessUnitConfig,
} from '@/modules/bu/registry.base';

export { BUSINESS_UNITS, BusinessUnitKey, getBusinessUnitConfig, type BusinessUnitConfig };

/**
 * Each product exposes its routes from `src/modules/<product>/bu.routes.ts`,
 * discovered here by filename for the same reason the configs are. Routes stay
 * out of `registry.base.ts` because they pull in middlewares, which import the
 * shared BU utils — importing them there would close a cycle.
 */
const routeModules = import.meta.glob<{
  key: BusinessUnitKey;
  default: RouteRecordRaw[];
  legacyRoutes?: RouteRecordRaw[];
}>('../*/bu.routes.ts', { eager: true });

export const getBusinessUnitRoutes = (key_value: BusinessUnitKey): RouteRecordRaw[] =>
  Object.values(routeModules).find((module) => module.key === key_value)?.default ?? [];

export const getBusinessUnitLegacyRoutes = (key_value: BusinessUnitKey): RouteRecordRaw[] =>
  Object.values(routeModules).find((module) => module.key === key_value)?.legacyRoutes ?? [];
